import type { FaireProductEntity } from "../../entity_types/product";

export const p_qp2gzqtexu: FaireProductEntity = {
  token: "p_qp2gzqtexu",
  type: "product",
  name: "Spooky Soap Stacks - Made in Canada",
  brandToken: "b_ddhqlsgav3",
  brandName: "SOAK Bath Co",
  imageUrl:
    "https://cdn.faire.com/fastly/3a5b43651f1bee58bab96fd02589a2b9915d1de915f852ed734915fe58257187.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a4c8e432652615af7392a89a9f694c3f3b5d6ec926f0b68769cab86eaaa4d907.jpeg",
    "https://cdn.faire.com/fastly/39b50340c48fbe1c69fa0e40d67a42f61c331de83ddd64716ea7e6071ca8e77f.jpeg",
    "https://cdn.faire.com/fastly/78463feb1c04d8797d76d4640bffc4b4f880bfe1a5315606eb7292cd1aa4c9f2.jpeg",
    "https://cdn.faire.com/fastly/4b6429c43b63229e1c0197f2eedba9f194d6d429e6c5c71e0660f8535132b396.jpeg",
  ],
  priceDollars: 7.5,
  description:
    "Spooky, but make it cute. Introducing the Spooky Soap Stack by SOAK Bath Co, the perfect sweet-smelling treat for Halloween. Scented with a beautiful, candy-inspired scent of cherry, this is the perfect gift for the kiddos this October or the friend that loves all-things-spooky. The scent notes on each of these adorable ghoulish stacks is cherry blended with almond, orange and a dash of cinnamon. \n\nEach Spooky Soap Stack includes the following shapes:\n\n * Bat \n * Ghost \n * Pumpkin \nProudly Made in Canada.\n\nFor our customers in the U.S.A., you will not be assessed tariffs on this product as it is CUSMA/USMCA compliant.\n\nPlease note that brokerage or duty fees may still apply depending on the status of the De Minimis exemption.\n\nSOAK Bath Co is a woman-owned brand based in Manitoba, Canada. Each of our products is handmade by our local team of women in our Canadian studio with all-natural, vegan-friendly ingredients. We believe in creating sustainable, eco-friendly products that make the best gifts and feel great using on your skin. What people love the most about SOAK Bath Co soap bars? You can plant the soap labels and they'll grow into wildflowers! At SOAK Bath Co we make bath and body products that are kind to the planet and kind on your skin.\n",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:45.560Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
